"use client";

import { useTranslation } from "react-i18next";
import RoomDetailItem from "./RoomDetailItem";

type RoomDetailItemsProps = {
  capacityAdults: number;
  beds: number;
  areaM2: number;
};

export default function RoomDetailItems({
  capacityAdults,
  beds,
  areaM2,
}: RoomDetailItemsProps) {
  const { t } = useTranslation();
  const bedText = beds === 1 ? t("bed") : t("beds");

  return (
    <>
      <RoomDetailItem icon="users" label={`${capacityAdults} ${t("people")}`} />
      <RoomDetailItem icon="bed" label={`${beds} ${bedText}`} />
      <RoomDetailItem icon="cube" label={`${areaM2} m²`} />
    </>
  );
}

